import { Grid2 } from '@mui/material'
import { SimpleColorPicker } from 'components/forms/ColorPicker'
import { StyledFieldSet, StyledLegend } from 'components/StyledElements'
import { PropTypes } from 'prop-types'
import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import useListIndexed from 'utils/customHook/useListIndexed'
import { RemarkLegend } from '../qualityComponents/Legend'
import { NewTable } from 'components/datatable/NewTable'

const QualityGraphicLegendPanel = ({
    analysis = [],
    stations = {},
    onChange = () => {},
}) => {
    const {
        qualitometers,
        citiesIndex,
    } = useSelector(store => ({
        qualitometers: store.QualityReducer.qualitometersLight,
        citiesIndex: store.CityReducer.citiesIndex,
    }), shallowEqual)

    const qualitometersIndex = useListIndexed(qualitometers, 'id')

    const formattedStations = useMemo(() => stations.map(({ id, color }) => {
        const qualito = qualitometersIndex[id]

        return {
            code: qualito?.code,
            name: qualito?.name,
            nullValue: (
                <>
                    <SimpleColorPicker
                        color={color}
                        style={{
                            margin: '4px',
                            width: '2rem',
                            height: '15px',
                            cursor: 'pointer',
                        }}
                        onChange={newColor => onChange(id, newColor)}
                        noLabel
                    />
                </>
            ),
            city: citiesIndex[qualito?.townCode]?.labelWithCode,
        }
    }), [qualitometersIndex, stations])

    return (
        <Grid2 container direction='column'>
            <StyledFieldSet /* style={{ height: '100%' }}*/>
                <StyledLegend>{`${i18n.stations} (${stations.length} ${stations.length === 1 ? i18n.element : i18n.elements})`}</StyledLegend>
                <NewTable
                    rows={formattedStations}
                    headers={['nullValue', 'code', 'city', 'name']}
                />
            </StyledFieldSet>
            <RemarkLegend
                list={analysis}
                col={4}
            />
        </Grid2>
    )
}

QualityGraphicLegendPanel.propTypes = {
    analysis: PropTypes.arrayOf(PropTypes.shape({
        // DtoAnalysis
        // calculateThresholdValue
    })),
    stations: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        color: PropTypes.string,
    })),
    onChange: PropTypes.func,
}

export default QualityGraphicLegendPanel